import React from 'react';
import { connect } from 'react-redux';
import { connectFromCrossSellWidget } from '@cart-js/trip';
import { mapStateToProps, mapTripStateToProps, OwnProps, HomeCrossSellFallbackComponentProps } from 'component/page/home/CrossSell/HomeCrossSellFallback.selectors';
import { compose } from '@reduxjs/toolkit';

const HomeCrossSellFallbackComponent: React.FC<HomeCrossSellFallbackComponentProps> = React.memo((props) => {
    if (props.apiLoadingState === 'Error' || props.apiLoadingState === 'NoData') {
        props?.onCartResponseFailure();
    }

    return null;
});

HomeCrossSellFallbackComponent.displayName = 'HomePageCrossSellFallbackComponent';

const enhance = compose<React.FC<OwnProps>>(connect(mapStateToProps), connectFromCrossSellWidget(mapTripStateToProps));

const HomeCrossSellFallback = enhance(HomeCrossSellFallbackComponent);
export { HomeCrossSellFallback, HomeCrossSellFallbackComponent };
